import styled from '@emotion/styled'
import { themeColor } from 'utils/styles'
import { isSummaryPath } from 'utils/utils'
import { Flex, Paragraph, Row } from 'components/patterns'
import { Typography } from 'antd'

const { Title } = Typography

const fullHeight = `
  display: flex;
  flex-direction: column;
  flex-grow: 1;
`

export const SummaryBodyContainer = styled(Flex)`
  overflow: hidden;
`

const selectTopMargin = (history) => (isSummaryPath(history) ? 0 : 16)

export const ContentBody = styled.div((props) => {
  const { history } = props
  const marginTop = selectTopMargin(history)
  return `
    margin-top: ${marginTop}px;
    padding: 0px 18px;
    gap: 25px;
    background-color: ${themeColor('offWhite', props)};
    ${fullHeight}

    .ant-tabs,
    .ant-tabs-content,
    .ant-tabs-tabspane {
      ${fullHeight}
    }
  `
})

export const StyledTitle = styled(Title)`
  color: ${themeColor('blackSecondary')} !important;
  font-size: 18px !important;
  font-weight: bold !important;
  margin: 0 !important;
`

export const FeatureRow = styled(Row)`
  background-color: ${themeColor('whitePrimary')};
  padding: 0 20px;
  margin-top: 20px;
`

export const NoModulesSection = styled(Flex)`
  min-height: 244px;
  border-radius: 3px;
  border: solid 1px ${themeColor('grey')};
  background-color: #f8f8f9;
`

export const NoModulesText = styled(Paragraph)`
  color: ${themeColor('greyPrimary')};
`

export const SectionSubTitle = styled.div`
  color: ${themeColor('blackSecondary')};
  & > p {
    margin: 0;
  }
`
